import { api } from "@/constants"
import { getAuthHeader, getAuthAndMultipartHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const article = {
  articleList: (params) => {
    const url = api.article.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  articleDetail: (id) => {
    const url = api.article.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  articleCreate: (payloads) => {
    const url = api.article.create
    return baseURL.post(url, payloads, { headers: getAuthAndMultipartHeader() })
  },
  articleDelete: (id) => {
    const url = api.article.delete(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  articleUpdate: (payloads, id) => {
    const url = api.article.update(id)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  }
}

export default article
